module.exports = __webpack_public_path__ + "482cba9b400598f608bae59c73c5ad08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/non-accommodation.svg
// module id = 3632
// module chunks = 6